import React, { useEffect, useState } from "react";
import { DefaultModalCommonProps } from "../CommentModal/CommentModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { ModalRow } from "../BlackListModal/BlackListModal";
import { ModalLabel } from "../CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../../AlimTalk/AlimTalkModal";
import { Input } from "../../../../Input/Input";
import { DeleteModalLabel } from "../CommentModal/CommentDeleteModal";
import { Textarea } from "../../../../Input/Textarea";
import Loader from "../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import AlertModal from "../../../../Modal/AlertModal";

interface Props extends DefaultModalCommonProps {
  uid: number;
}

export default function NewLinkidMailEditModal({
  closeEvent,
  confirmEvent,
  uid,
}: Props) {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [alert, setAlert] = useState(false);
  const [execute, setExecute] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: execute ? `user/mail` : undefined,
    data: {
      uid,
      addr: email.replaceAll("-", ""),
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
      toast.success("링키드 메일을 수정했습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "링키드 메일 수정에 실패했습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => setAlert(true)}
      modalTitle="링키드 메일 수정"
      isMediumModal={true}
      confirmDisabled={reason === ""}
    >
      <>
        <ModalRow>
          <ModalLabel>이메일 입력</ModalLabel>

          <ModalRowContentContainer>
            <Input
              placeholder="이메일을 입력해주세요"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
            />
          </ModalRowContentContainer>
        </ModalRow>

        <DeleteModalLabel>등록 사유</DeleteModalLabel>

        <Textarea
          placeholder="등록 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />

        {alert && (
          <AlertModal
            title={"링키드 메일을 수정하시겠습니까?"}
            cancelEvent={() => setAlert(false)}
            confirmEvent={() => setExecute(true)}
            btnColor="mint"
          />
        )}

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
